module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.getStudentSummary.submission) ? _c('div', [_c('div', {
    staticClass: "flex justify-between items-center px-2 py-1 z-10 bg-white",
    staticStyle: {
      "height": "41px"
    }
  }, [_c('div', {
    staticClass: "flex items-center space-x-3.5 rounded-full"
  }, [_c('div', {
    class: ['flex items-center space-x-1.5 font-manrope font-semibold rounded-full py-1.5 px-1.5 text-gray-800', {
      'border border-solid border-gray-200': _vm.hasTeacherPermissionsInCourse
    }]
  }, [(_vm.hasTeacherPermissionsInCourse) ? _c('button', {
    staticClass: "disabled:opacity-50 bg-gray-100 hover:bg-gray-200 w-7 h-7 rounded-full flex items-center justify-center",
    attrs: {
      "disabled": _vm.loading || _vm.orderedSubmissions.length <= 1
    },
    on: {
      "mouseenter": function($event) {
        _vm.hovered = true
      },
      "mouseleave": function($event) {
        _vm.hovered = false
      },
      "click": function($event) {
        return _vm.handleChangeParticipant(_vm.getStudentSummary.submission_id, 'previous')
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-angle-left"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2.5",
    attrs: {
      "title": _vm.studentNames ? _vm.getStudentSummary.user.name : _vm.getStudentSummary.submission.anonymous_identity.name
    }
  }, [_c('img', {
    staticClass: "rounded-full w-6 h-6",
    attrs: {
      "src": _vm.studentNames ? _vm.getStudentSummary.user.avatar_url : _vm.getStudentSummary.submission.anonymous_identity.avatar_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex items-center"
  }, [_c('span', {
    staticClass: "text-gray-800 text-base",
    class: _vm.hasTeacherPermissionsInCourse ? 'w-32 truncate' : 'pr-2'
  }, [_vm._v("\n              " + _vm._s(_vm.studentNames ? _vm.getStudentSummary.user.name : _vm.getStudentSummary.submission.anonymous_identity.name) + "\n            ")]), _vm._v(" "), (_vm.getProfile.id === _vm.getStudentSummary.user.id) ? _c('span', {
    staticClass: "font-manrope font-semibold text-pinky"
  }, [_vm._v("\n              (Me)\n            ")]) : _vm._e()])]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('button', {
    staticClass: "disabled:opacity-50 bg-gray-100 hover:bg-gray-200 w-7 h-7 rounded-full flex items-center justify-center",
    attrs: {
      "disabled": _vm.loading || _vm.orderedSubmissions.length <= 1
    },
    on: {
      "mouseenter": function($event) {
        _vm.hovered = true
      },
      "mouseleave": function($event) {
        _vm.hovered = false
      },
      "click": function($event) {
        return _vm.handleChangeParticipant(_vm.getStudentSummary.submission_id, 'next')
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-angle-right"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-1"
  }, [_c('div', [(_vm.isFeedbackEnable && !_vm.hasAssessments && _vm.hasTeacherPermissionsInCourse) ? _c('button', {
    staticClass: "bg-primary hover:bg-primary-dark text-white h-9 rounded-full flex items-center justify-center space-x-2 px-5 font-manrope",
    on: {
      "click": function($event) {
        return _vm.handleSubmit()
      }
    }
  }, [_c('span', [_vm._v("Send")]), _vm._v(" "), _c('i', {
    staticClass: "fa-solid fa-arrow-right"
  })]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "bg-gray-100 hover:bg-primary-new_light hover:text-primary w-9 text-gray-600 h-9 text-lg rounded-full flex items-center justify-center",
    on: {
      "click": function($event) {
        return _vm.$emit('backToOnlineStudentList')
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-close text-base"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "max-height-list px-2 pb-4 mt-3"
  }, [_c('div', {
    staticClass: "w-full h-full"
  }, [_c('div', {
    staticClass: "flex justify-between items-center w-full space-x-2"
  }, [_c('div', {
    staticClass: "bg-gray-100 rounded-lg flex items-center justify-between pl-3 pr-2 py-1.5 cursor-pointer w-full"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2",
    on: {
      "click": function($event) {
        _vm.isAssessmentCollapsed = !_vm.isAssessmentCollapsed
      }
    }
  }, [_c('button', {
    staticClass: "hover:bg-gray-200 hover:text-gray-800 text-gray-600 w-7 h-7 rounded-full"
  }, [_c('i', {
    staticClass: "fa-solid",
    class: !_vm.isAssessmentCollapsed ? 'fa-angle-down' : 'fa-angle-up'
  })]), _vm._v(" "), _c('h6', {
    staticClass: "text-gray-800 font-manrope font-semibold"
  }, [_vm._v("Assessment & Feedback")]), _vm._v(" "), _c('div', {
    staticClass: "font-manrope text-base"
  }, [(_vm.hasTeacherPermissionsInCourse && _vm.hasAssessments) ? _c('div', {
    staticClass: "flex items-center space-x-2 font-manrope"
  }, [_c('span', {
    staticClass: "text-green-500 text-xs"
  }, [_vm._v("(Sent)")])]) : (_vm.hasTeacherPermissionsInCourse && _vm.hasDraftAssessment) ? _c('div', {
    staticClass: "flex items-center space-x-2 font-manrope"
  }, [_c('span', {
    staticClass: "text-yellow-500 text-xs"
  }, [_vm._v("(Draft)")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-1"
  }, [(_vm.hasTeacherPermissionsInCourse && (!_vm.hasAssessments || !_vm.hasFeedback)) ? _c('button', {
    staticClass: "hover:bg-gray-200 pl-2 pr-2.5 h-8 rounded-lg text-gray-800 flex items-center space-x-3",
    on: {
      "click": function($event) {
        return _vm.handleGradeIndividualAssessment()
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('pl-menu', {
    attrs: {
      "direction": "right",
      "menuSize": 5
    }
  }, [(_vm.hasTeacherPermissionsInCourse) ? _c('button', {
    staticClass: "select-none mr-1.5 w-7 h-7 hover:bg-gray-200 font-manrope text-gray-700 rounded-full flex justify-center items-center",
    attrs: {
      "slot": "menu_trigger"
    },
    slot: "menu_trigger"
  }, [_c('img', {
    staticClass: "w-3.5 h-3.5",
    attrs: {
      "src": "/static/settings.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rounded-lg mt-0.5 shadow-sm px-1 pt-0.5 pb-1 font-manrope text-sm text-gray-800 select-none",
    attrs: {
      "menu-content": ""
    }
  }, [_c('div', {
    staticClass: "flex flex-col space-y-3"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-1.5"
  }, [_c('h6', {
    staticClass: "font-manrope text-xs text-gray-500 mx-2 mt-1"
  }, [_vm._v("Length")]), _vm._v(" "), _c('ul', _vm._l((_vm.lengthOptions), function(lengthOption, index) {
    return _c('li', {
      key: index,
      staticClass: "px-2 py-1.5 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-2",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleCheckLenghtOption(lengthOption)
        }
      }
    }, [_c('input', {
      staticClass: "cursor-pointer",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": lengthOption === _vm.selectedLengthOption
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(lengthOption))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2 px-3"
  }, [_c('toggle-button', {
    attrs: {
      "sync": true,
      "labels": false,
      "height": 16,
      "width": 28,
      "color": "#eb2d7c"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    model: {
      value: (_vm.isCriteriaFeedbackOn),
      callback: function($$v) {
        _vm.isCriteriaFeedbackOn = $$v
      },
      expression: "isCriteriaFeedbackOn"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-manrope text-gray-800"
  }, [_vm._v("Feedback On Criteria")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-1.5"
  }, [_c('div', {
    staticClass: "flex items-center space-x-1 mx-2 mt-1"
  }, [_c('h6', {
    staticClass: "font-manrope text-xs text-gray-500"
  }, [_vm._v("Instructions")])]), _vm._v(" "), _c('li', {
    staticClass: "px-2 py-1.5 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-3",
    on: {
      "click": function($event) {
        return _vm.handleEditInstructions()
      }
    }
  }, [_c('i', {
    staticClass: "fa-regular fa-pen-to-square text-gray-800 ml-1"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-gray-800"
  }, [_vm._v("Edit Instructions")])]), _vm._v(" "), _c('ul', [_vm._l((_vm.getProfile.instructions), function(instruction, index) {
    return _c('li', {
      key: instruction.id,
      staticClass: "px-2 py-1 rounded-md cursor-pointer hover:bg-gray-100 flex justify-between items-center space-x-2",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleCheckInstruction(instruction)
        }
      }
    }, [_c('div', {
      staticClass: "flex items-center space-x-2 w-10/12 min-w-0"
    }, [_c('input', {
      staticClass: "cursor-pointer flex-none",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": instruction.id === _vm.selectedInstruction.id
      },
      on: {
        "change": function($event) {
          $event.stopPropagation();
          return _vm.handleCheckInstruction(instruction)
        },
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "flex-1 truncate"
    }, [_vm._v("\n                            " + _vm._s(instruction.title) + "\n                          ")])]), _vm._v(" "), _c('div', {
      staticClass: "text-xs"
    }, [_c('button', {
      staticClass: "w-6 h-6 rounded-full text-red-500 hover:text-red-600 hover:bg-red-100",
      attrs: {
        "title": "Delete"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDeleteInstruction(instruction)
        }
      }
    }, [_c('i', {
      staticClass: "fa-solid fa-minus"
    })])])])
  }), _vm._v(" "), _c('li', {
    staticClass: "px-2 py-1.5 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-3",
    on: {
      "click": function($event) {
        return _vm.handleOpenNewInstructionModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-plus text-primary ml-1"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-gray-800"
  }, [_vm._v("New Instruction")])])], 2)])])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "relative w-full h-full"
  }, [(_vm.getCurrentRT.enable_grading && _vm.isAssessmentCollapsed === true) ? _c('div', {
    staticClass: "flex flex-col space-y-2 mt-3 mb-4"
  }, [_vm._l((_vm.assessments), function(assessment, index) {
    return _c('div', {
      key: assessment.tag,
      staticClass: "flex flex-col px-2.5 pt-2 pb-2 bg-white border border-gray-200 rounded-lg"
    }, [_c('div', {
      staticClass: "flex items-center justify-between"
    }, [_c('div', {
      staticClass: "flex items-center"
    }, [_c('h6', {
      staticClass: "flex-1 p-2 font-poppins text-gray-800"
    }, [_vm._v(_vm._s(assessment.title))]), _vm._v(" "), _c('Popper', {
      attrs: {
        "append-to-body": true,
        "prevent-default": true,
        "options": {
          placement: 'left-bottom',
          modifiers: {
            offset: {
              offset: '0,0px'
            }
          }
        },
        "trigger": "hover"
      }
    }, [(_vm.getAssessmentInfo(assessment)[0].description) ? _c('div', {
      staticClass: "popper flex flex-col space-y-2 py-3 px-4 bg-white rounded-md shadow-none border border-solid border-gray-200 w-72 cursor-pointer"
    }, [_c('div', [_c('h5', {
      staticClass: "font-bold text-sm font-manrope text-left"
    }, [_vm._v(_vm._s(_vm.getAssessmentInfo(assessment)[0].title))])]), _vm._v(" "), _c('div', {
      staticClass: "text-left text-xs text-gray-600"
    }, [_c('div', {
      staticClass: "html-content font-manrope",
      domProps: {
        "innerHTML": _vm._s(typeof _vm.getAssessmentInfo(assessment)[0].description === 'object' ? _vm.getAssessmentInfo(assessment)[0].description.join('. ') : _vm.getAssessmentInfo(assessment)[0].description)
      }
    }), _vm._v(" "), _vm._l((_vm.getAssessmentInfo(assessment)[0].points_description), function(point) {
      return _c('div', {
        staticClass: "flex flex-col space-y-2"
      }, [_c('div', {
        staticClass: "flex items-center space-x-1 mb-2"
      }, [_c('div', {
        staticClass: "flex flex-col space-y-1"
      }, [_c('span', {
        staticClass: "font-semibold font-poppins text-gray-800"
      }, [_vm._v("(" + _vm._s(point.value) + ") Level: ")]), _vm._v(" "), _c('span', {
        staticClass: "text-gray-700"
      }, [_vm._v(_vm._s(point.description))])])])])
    })], 2)]) : _vm._e(), _vm._v(" "), (_vm.getAssessmentInfo(assessment)[0].description) ? _c('button', {
      ref: "btnRef",
      refInFor: true,
      staticClass: "flex items-center justify-center mr-3 cursor-pointer w-3.5 h-3.5 rounded-full text-white hover:bg-gray-700 bg-gray-400",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "fa-solid fa-question",
      staticStyle: {
        "font-size": "7px"
      }
    })]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
      staticClass: "flex items-center space-x-1 text-gray-600"
    }, [(_vm.hasTeacherPermissionsInCourse) ? _c('button', {
      staticClass: "w-7 h-7 rounded-lg hover:bg-gray-200 flex items-center justify-center",
      attrs: {
        "disabled": Number(assessment.value) === 0
      },
      on: {
        "click": function($event) {
          return _vm.handleChangeCriteriaPoint(index, 'minus')
        }
      }
    }, [_c('i', {
      staticClass: "fa-solid fa-minus text-xs"
    })]) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (assessment.value),
        expression: "assessment.value"
      }],
      class: [
        'w-8 h-8 rounded-lg flex items-center text-center justify-center text-gray-800 border-0',
        _vm.getColourClass(assessment.value)
      ],
      attrs: {
        "disabled": !_vm.hasTeacherPermissionsInCourse
      },
      domProps: {
        "value": (assessment.value)
      },
      on: {
        "change": function($event) {
          return _vm.handleChangeManualCriteriaPoint(index, $event.target.value)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(assessment, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('button', {
      staticClass: "w-7 h-7 rounded-lg hover:bg-gray-200 flex items-center justify-center",
      attrs: {
        "disabled": _vm.getCurrentRT.point_cap !== null ? Number(assessment.value) >= Number(_vm.getCurrentRT.point_cap) : false
      },
      on: {
        "click": function($event) {
          return _vm.handleChangeCriteriaPoint(index, 'plus')
        }
      }
    }, [_c('i', {
      staticClass: "fa-solid fa-plus text-xs"
    })]) : _vm._e()])]), _vm._v(" "), (_vm.isCriteriaFeedbackOn) ? _c('div', {
      staticClass: "mx-2 font-manrope text-gray-800 flex flex-col"
    }, [(_vm.hasTeacherPermissionsInCourse || (assessment.feedback != null && assessment.feedback.trim().length > 0)) ? _c('textarea-autosize', {
      staticClass: "focus-within:outline-none outline-none bg-white mb-1",
      attrs: {
        "placeholder": _vm.hasTeacherPermissionsInCourse ? 'Write specific feedback...' : 'No feedback...',
        "disabled": !_vm.hasTeacherPermissionsInCourse
      },
      on: {
        "input": _vm.debouncedSaveAssessment
      },
      model: {
        value: (_vm.assessments[index].feedback),
        callback: function($$v) {
          _vm.$set(_vm.assessments[index], "feedback", $$v)
        },
        expression: "assessments[index].feedback"
      }
    }) : _vm._e()], 1) : _vm._e()])
  }), _vm._v(" "), (_vm.assessments.length) ? _c('div', {
    staticClass: "flex items-center justify-between font-manrope pt-1.5 px-2"
  }, [_c('span', {
    staticClass: "text-gray-800"
  }, [_vm._v("Total Points")]), _vm._v(" "), _c('span', {
    staticClass: "flex justify-center"
  }, [_c('span', {
    staticClass: "flex justify-center items-center h-9 w-9 rounded-lg border border-solid border-gray-200"
  }, [_vm._v("\n                " + _vm._s(_vm.assessmentTotalPoints) + "\n              ")])])]) : _vm._e()], 2) : (_vm.isAssessmentCollapsed === true && _vm.hasTeacherPermissionsInCourse && (!_vm.getCurrentRT.enable_grading || !_vm.getCurrentRT.points_settings.peer_rewards.length)) ? _c('div', {
    staticClass: "flex flex-col items-center justify-center mt-3 mb-3 p-8 font-manrope rounded-lg text-center text-gray-700"
  }, [_c('i', {
    staticClass: "fa-solid fa-triangle-exclamation text-3xl mb-2"
  }), _vm._v(" "), _c('h2', {
    staticClass: "text-lg font-semibold mb-1"
  }, [_vm._v("No Criteria Set")]), _vm._v(" "), _c('p', {
    staticClass: "text-sm text-gray-500 mb-5"
  }, [_vm._v("\n            You need to enable assessment criteria to continue.\n          ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-3 w-full relative h-full"
  }, [(_vm.isAssessmentCollapsed === true) ? _c('div', {
    staticClass: "w-full h-full rounded-lg mt-3 transition-colors border border-solid border-gray-200 focus-within:ring-2 focus-within:ring-pinky-light ring-offset-2"
  }, [(_vm.hasTeacherPermissionsInCourse || _vm.hasFeedback) ? _c('textarea-autosize', {
    ref: "assessment-textarea",
    staticClass: "px-4 py-3 w-full h-full rounded-lg outline-none font-manrope text-gray-800 bg-white",
    attrs: {
      "placeholder": ("Write general feedback to " + _vm.currentUserName + ", or use Genie..."),
      "disabled": !_vm.hasTeacherPermissionsInCourse || _vm.getCurrentRT.is_genie_grader_running === true
    },
    on: {
      "input": _vm.debouncedSaveFeedback
    },
    model: {
      value: (_vm.evaluation.comment),
      callback: function($$v) {
        _vm.$set(_vm.evaluation, "comment", $$v)
      },
      expression: "evaluation.comment"
    }
  }) : _c('div', {
    staticClass: "p-2.5"
  }, [_vm._v("There is currently no feedback here...")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "bg-gray-100 rounded-lg flex items-center space-x-3 px-3 py-2 cursor-pointer",
    on: {
      "click": function($event) {
        _vm.isCommentsCollapsed = !_vm.isCommentsCollapsed
      }
    }
  }, [_c('button', {
    staticClass: "hover:bg-gray-200 hover:text-gray-800 text-gray-600 w-7 h-7 rounded-full"
  }, [_c('i', {
    staticClass: "fa-solid",
    class: !_vm.isCommentsCollapsed ? 'fa-angle-down' : 'fa-angle-up'
  })]), _vm._v(" "), _c('span', {
    staticClass: "font-semibold text-gray-800 font-manrope"
  }, [_vm._v("\n            " + _vm._s(_vm.getStudentSummary.my_comments.length === 1 ? 'Comment Made' : 'Comments Made') + "\n            (" + _vm._s(_vm.getStudentSummary.my_comments.length) + ")\n          ")])]), _vm._v(" "), (_vm.isCommentsCollapsed) ? _c('CommentSummary', {
    class: [_vm.getStudentSummary.my_comments.length ? 'mt-2 pl-2' : '']
  }) : _vm._e()], 1)])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-1 font-manrope"
  }, [_c('div', {
    staticClass: "w-7 h-7 overflow-hidden -ml-1"
  }, [_c('iframe', {
    staticClass: "transform scale-150 w-full h-full",
    attrs: {
      "src": "https://lottie.host/embed/874b8bf3-ca7e-46f3-9c81-cf94974ad30b/Djg5qZsQK9.lottie"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Generate")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-044cf57e!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/onlineStudentsAssessment.vue
// module id = 1261
// module chunks = 61